import React, { useState, useEffect } from "react";
import * as httpClient from "../../../util/httpClient";
import { useDispatch } from "react-redux";
import { Notification } from "../../common/Notification";
import { useTranslation } from "react-i18next";

const ConfirmDeleteWalletDialog: React.FunctionComponent<{ requestDataCallback(): void; walletItem: any; itemType: string; closeDialog(): void }> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);

    const dispatch = useDispatch();
    const [itemTitle, setItemTitle] = useState("");

    useEffect(() => {
        const title = getItemTitle();
        setItemTitle(title);
    }, []);

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refresWalletItem = () => {
        closeDialog();
        props.requestDataCallback();
    };

    const getItemTitle = () => {
        switch (props.itemType) {
            case "credit-card":
                return (
                    tLang("identityVault.secureStorage.lostWallterWidget.creditDebitCardPopup.title2", {
                        cardType: props.walletItem.cardCategory ? props.walletItem.cardCategory : "Credit/Debit Card",
                    }) +
                    ", " +
                    props.walletItem.cardName
                );
            case "bank-account":
                return tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.title2") + ", " + props.walletItem.institutionName;
            case "driver-licence":
                return (
                    tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.title2") +
                    ", " +
                    props.walletItem.firstName +
                    " " +
                    props.walletItem.lastName
                );
            case "medical-id-card":
                return tLang("identityVault.secureStorage.lostWallterWidget.medicalIdCard.title2") + ", " + props.walletItem.cardType;
            case "id-card":
                return (
                    tLang("identityVault.secureStorage.lostWallterWidget.cardPopup.title2") + ", " + props.walletItem.firstName + " " + props.walletItem.lastName
                );
            case "ssn":
                return (
                    tLang("identityVault.secureStorage.lostWallterWidget.socialSecurityCard.title2") +
                    ", " +
                    props.walletItem.firstName +
                    " " +
                    props.walletItem.lastName
                );
            case "passport":
                return tLang("identityVault.secureStorage.lostWallterWidget.passport.title2") + ", " + props.walletItem.firstName + " " + props.walletItem.lastName;
            case "reward-card":
                return tLang("identityVault.secureStorage.lostWallterWidget.customerRewardCard.title2") + ", " + props.walletItem.cardName;
            case "combination":
                return tLang("identityVault.secureStorage.lostWallterWidget.combination.title2") + ", " + props.walletItem.itemName;
            case "family-member":
                return "Family Member, " + props.walletItem.firstName + " " + props.walletItem.lastName;
            default:
                return "";
        }
    };

    const getDeleteItem = () => {
        switch (props.itemType) {
            case "credit-card":
                return {
                    "lost-wallet-creditcard": props.walletItem,
                };
            case "bank-account":
                return {
                    "lost-wallet-bankacc": props.walletItem,
                };
            case "driver-licence":
                return {
                    "lost-wallet-driver": props.walletItem,
                };
            case "medical-id-card":
                return {
                    "lost-wallet-medicalcard": props.walletItem,
                };
            case "id-card":
                return {
                    "lost-wallet-genericcard": props.walletItem,
                };
            case "ssn":
                return {
                    "lost-wallet-ssn": props.walletItem,
                };
            case "passport":
                return {
                    "lost-wallet-passport": props.walletItem,
                };
            case "reward-card":
                return {
                    "lost-wallet-customerreward": props.walletItem,
                };
            case "combination":
                return {
                    "lost-wallet-combination": props.walletItem,
                };
            case "family-member":
                return {
                    "lost-family-member": props.walletItem,
                };
            default:
                return "";
        }
    };

    const deleteWalletItem = () => {
        const requestBody = {
            "lost-wallet": getDeleteItem(),
        };
        setisLoading(true);
        httpClient
            .sendRequest("POST", `api/lostWallet/deleteWalletItem`, requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.isSuccess) {
                    Notification({
                        type: "success",
                        title: tLang("identityVault.secureStorage.lostWallterWidget.deleteToastTitle"),
                        message: tLang("identityVault.secureStorage.lostWallterWidget.deleteToastMessage", { itemTitle: itemTitle }),
                    });
                    refresWalletItem();
                } else {
                    Notification({
                        type: "error",
                        title: tLang("identityVault.secureStorage.lostWallterWidget.errorToastTitle"),
                        message: tLang("identityVault.secureStorage.lostWallterWidget.errorToastMesage"),
                        duration: 0,
                    });
                    closeDialog();
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.secureStorage.lostWallterWidget.errorToastTitle"),
                    message: tLang("identityVault.secureStorage.lostWallterWidget.errorToastMesage"),
                    duration: 0,
                });
                closeDialog();
            });
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-trash"></em>
                        </div>
                        <h1>{tLang("identityVault.secureStorage.lostWallterWidget.deleteWalletItemPopup.title")}</h1>
                    </div>

                    <div className="dialog-body">
                        <p>
                            {tLang("identityVault.secureStorage.lostWallterWidget.deleteWalletItemPopup.message")} <strong>{itemTitle}?</strong>
                        </p>
                    </div>

                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                    <span className="btn-text">
                                        {tLang("identityVault.secureStorage.lostWallterWidget.deleteWalletItemPopup.cancelButtonText")}
                                    </span>
                                </button>
                            </div>
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-red" onClick={() => deleteWalletItem()}>
                                    <span className="btn-icon">
                                        <em className="las la-trash-alt"></em>
                                    </span>
                                    <span className="btn-text">
                                        {tLang("identityVault.secureStorage.lostWallterWidget.deleteWalletItemPopup.deleteButtonText")}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default ConfirmDeleteWalletDialog;
